import React, { useEffect, useState } from 'react';
import { usePlayrooms } from '../../context/PlayroomsContext';
import { useBooking } from '../../context/BookingContext';
import { Button, Checkbox, Spin, message } from 'antd';
import bookingService from '../../services/booking.service';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import PlayroomCard from '../../components/PlayroomCard';
import PackageCard from '../../components/PackageCard';

export default function ReservationReview() {
    dayjs.extend(utc);
    const { choosenPlayroom } = usePlayrooms();
    const { bookingState } = useBooking();
    const navigate = useNavigate();
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [termsError, setTermsError] = useState(false);

    useEffect(() => {
        console.log(findSelectedPackage());
        if (bookingState.from === null || bookingState.to === null) {
            navigate("/");
        }
    }, [bookingState.from, bookingState.to, navigate]);

    const findSelectedPackage = () => {
        return choosenPlayroom?.packages.find((x) => x?.id === bookingState?.packageId);
    };

    if (bookingState.from === null || bookingState.to === null) {
        return <Spin />;
    }

    const getTimeFromTimeStamp = (timestamp) => {
        return dayjs.utc(timestamp).format('HH:mm');
    };

    const formatDateTime = (timestamp) => {
        return dayjs.utc(timestamp).format('DD.MM.YYYY');
    };

    const isBookingDataComplete = bookingState?.from && bookingState?.to && bookingState?.customerFirstName !== '';

    if (!isBookingDataComplete) {
        return (
            <div className="flex items-center justify-center h-screen bg-blue-100">
                <Spin size="large" />
            </div>
        );
    }

    const onsubmit = () => {
        console.log(bookingState);
        if (!isTermsAccepted) {
            message.error("Morate prihvatiti uslove korišćenja.");
            return;
        }
        bookingService.createNewBooking(bookingState)
            .then((response) => {
                if (response.status === 200) {
                    message.success("Uspješno ste poslali rezervaciju");
                    navigate("/finish");
                } else {
                    message.error("Greška prilikom slanja rezervacije");
                    navigate("/");
                }
            }).catch((err) => {
                console.log(err);
            });
    };

    const handleCheckboxChange = (e) => {
        setIsTermsAccepted(e.target.checked);
        setTermsError(false); // Reset error on change
    };

    return (
        <div className="min-h-screen flex flex-col">
            {/* Outer div */}
            <div className="flex flex-col h-full">
                {/* First inner div for title */}
                <div className="p-4 ">
                    <p className="text-3xl lg:text-6xl font-bold text-footerBlue">
                        Vaša rezervacija
                    </p>
                    <label
                        className="block text-footerBlue font-semibold text-xl lg:py-4"
                        htmlFor="expectedNumberOfAdults"
                    >
                        Molimo Vas pregledajte vašu rezervaciju
                    </label>
                </div>

                {/* Second inner div for data */}
                <div className="flex-grow p-4 md:px-20 justify-center items-center">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div className="p-4 ">
                            <PlayroomCard />
                        </div>
                        <div className="p-4">
                            <PackageCard pkg={findSelectedPackage()} />
                        </div>
                        <div className="p-4 ">
                            <div className="bg-datepickerGray h-full w-full rounded-[35px] p-6 shadow-lg ">
                                <h2 className="text-footerBlue font-bold mb-4 text-left text-xl md:text-2xl">Podaci o korisniku</h2>
                                <p className="text-gray-600 text-left font-semibold text-lg md:text-xl">
                                    {`Termin rođendana: ${formatDateTime(bookingState.from)}`}
                                </p>
                                <p className="text-gray-600 text-left font-semibold text-lg md:text-xl pb-4">
                                    {`Vrijeme rođendana: ${getTimeFromTimeStamp(bookingState.from)} - ${getTimeFromTimeStamp(bookingState.to)}`}
                                </p>
                                <p className="text-gray-600 text-left font-semibold text-lg md:text-xl ">
                                    {`${bookingState?.customerFirstName} ${bookingState?.customerLastName}`}
                                </p>
                                <p className="text-gray-600 text-left font-semibold text-lg md:text-xl">
                                    {bookingState?.childName}
                                </p>
                                <p className="text-gray-600 text-left font-semibold text-lg md:text-xl">
                                    {bookingState?.customerPhoneNumber}
                                </p>
                                <p className="text-gray-600 text-left font-semibold text-lg md:text-xl">
                                    {bookingState?.customerEmail}
                                </p>

                                <div className="flex items-center px-7 pt-2">
                                    <Checkbox
                                        className="transform scale-125"
                                        checked={isTermsAccepted}
                                        onChange={handleCheckboxChange}
                                    >
                                        <p className="text-footerBlue text-left font-semibold">
                                            Slažem se sa uslovima korišćenja.
                                        </p>
                                    </Checkbox>
                                    {/* {termsError && (
                                        <p className="text-red-500 text-sm">
                                            Morate prihvatiti uslove korišćenja.
                                        </p>
                                    )} */}
                                </div>
                            </div>
                        </div>
                        <div className="p-4">
                            <div className="bg-noteBgRed h-full w-full rounded-[35px] p-8 shadow-lg space-y-3">

                                <p className="text-noteDetailsRed text-left font-semibold text-lg md:text-xl">
                                    Napomena od igraonice! 
                                </p>

                                <p className="text-noteDetailsRed text-left font-semibold text-lg md:text-xl">
                                U slučaju da su email i broj telefona pogrešni rezervacija će biti nevažeća. 
                                </p>
                                <p className="text-noteDetailsRed text-left font-semibold text-lg md:text-xl">
                                    Nakon rezervacije će na Vaš mail stići podaci za uplatu avansa. Kada uplatite avans, igraonica će odobriti Vaš termin.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-4">
                    <Button
                        type="submit"
                        onClick={onsubmit}
                        className="bg-submitButtonGreen text-white hover:bg-buttonYellow hover:text-footerBlue text-xl rounded-[36px] font-bold py-6 md:py-8"
                    // disabled={!isTermsAccepted}
                    >
                        POTVRDI REZERVACIJU
                    </Button>
                </div>
            </div>
        </div>
    );
}
